import { render, staticRenderFns } from "./_iframe.vue?vue&type=template&id=22f1e1b2&"
import script from "./_iframe.vue?vue&type=script&lang=js&"
export * from "./_iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports